export const copyJWTLink = `javascript: (() => {
    const oldFocus = document.activeElement; 
    var d = {};
    for ( var i = 0, len = localStorage.length; i < len; ++i ) {
        if (localStorage.key( i ).startsWith('CognitoIdentityServiceProvider')) {
            d[localStorage.key( i )] = localStorage.getItem( localStorage.key( i ));
        }
    }
    oldFocus.focus(); 
    navigator.clipboard.writeText(JSON.stringify(d));
})();`;

export const pasteJWTLink = `javascript: (() => {
    const oldFocus = document.activeElement; 
    oldFocus.focus(); 
    navigator.clipboard
    .readText()
    .then(
        (clipText) => {
            var d = JSON.parse(clipText);
            for (const [key, value] of Object.entries(d)) {
                localStorage.setItem(key, value);
            }
            location.reload();
        }
    );
})();`;
